import createBreakpoints from '@material-ui/core/styles/createBreakpoints'
import { createMuiTheme } from '@material-ui/core/styles/index'

function pxToRem(value) {
    return `${value / 16}rem`
}

const getTheme = theme => {
    const pSBC = (p, c0, c1, l) => {
        let r,
            g,
            b,
            P,
            f,
            t,
            h,
            i = parseInt,
            m = Math.round,
            a = typeof c1 == 'string'
        if (typeof p != 'number' || p < -1 || p > 1 || typeof c0 != 'string' || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null
        const pSBCr = d => {
            let n = d.length,
                x = {}
            if (n > 9) {
                ;([r, g, b, a] = d = d.split(',')), (n = d.length)
                if (n < 3 || n > 4) return null
                ;(x.r = i(r[3] == 'a' ? r.slice(5) : r.slice(4))), (x.g = i(g)), (x.b = i(b)), (x.a = a ? parseFloat(a) : -1)
            } else {
                if (n == 8 || n == 6 || n < 4) return null
                if (n < 6) d = '#' + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : '')
                d = i(d.slice(1), 16)
                if (n == 9 || n == 5) (x.r = (d >> 24) & 255), (x.g = (d >> 16) & 255), (x.b = (d >> 8) & 255), (x.a = m((d & 255) / 0.255) / 1000)
                else (x.r = d >> 16), (x.g = (d >> 8) & 255), (x.b = d & 255), (x.a = -1)
            }
            return x
        }
        ;(h = c0.length > 9),
            (h = a ? (c1.length > 9 ? true : c1 == 'c' ? !h : false) : h),
            (f = pSBCr(c0)),
            (P = p < 0),
            (t =
                c1 && c1 != 'c'
                    ? pSBCr(c1)
                    : P
                    ? {
                          r: 0,
                          g: 0,
                          b: 0,
                          a: -1
                      }
                    : { r: 255, g: 255, b: 255, a: -1 }),
            (p = P ? p * -1 : p),
            (P = 1 - p)
        if (!f || !t) return null
        if (l) (r = m(P * f.r + p * t.r)), (g = m(P * f.g + p * t.g)), (b = m(P * f.b + p * t.b))
        else
            (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
                (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
                (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5))
        ;(a = f.a), (t = t.a), (f = a >= 0 || t >= 0), (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0)
        if (h) return 'rgb' + (f ? 'a(' : '(') + r + ',' + g + ',' + b + (f ? ',' + m(a * 1000) / 1000 : '') + ')'
        else return '#' + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
    }

    const breakpoints = createBreakpoints({})

    const spacing = theme.spacing ? theme.spacing : 8

    const baseTheme = {
        material: {
            breakpoints,
            typography: {
                useNextVariants: true,
                fontFamily: '"' + theme.bodyFontFamily + '", sans-serif'
            },
            root: {
                marginTop: '0px!important',
                paddingBottom: 0
            },
            paper: {
                boxShadow: '0 12px 24px rgba(0, 0, 0, 0.15)!important',
                marginBottom: spacing * 3,
                paddingTop: spacing * 2 + 'px!important',
                background: theme.paperBackground
            },
            header: {
                background: '#ffffff'
            },
            title: {
                paddingTop: spacing * 1.5,
                paddingBottom: spacing * 3
            },
            description: {
                marginBottom: spacing * 2,
                emptyMarginBottom: 0
            },
            button: {
                boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)!important'
            },
            selectButtons: {
                marginTop: spacing * 2
            },
            selectButton: {
                boxShadow: 'none!important',
                border: '1px solid ' + pSBC(0.3, theme.primaryColor),
                color: theme.primaryColor,
                background: 'transparent',
                hoverBackground: pSBC(0.9, theme.primaryColor),
                hoverBorder: '1px solid ' + theme.primaryColor
            },
            selectedButton: {
                border: '1px solid ' + theme.primaryColor
            },
            input: {
                border: '1px solid rgba(0, 0, 0, 0.3)'
                //border: '1px solid ' + pSBC(0.3, theme.primaryColor)
            },
            forwardButton: {
                color: '#fff!important',
                background: '#04afff!important',
                //boxShadow: 'none!important',
                width: 'auto',
                maxWidth: 498,
                marginTop: spacing * 0.8,
                marginBottom: spacing * 1.25
            },
            backButton: {
                color: 'rgba(0, 0, 0, 0.61)!important',
                marginTop: spacing * 0.8,
                marginBottom: spacing * 1,
                width: 'auto',
                maxWidth: 498
            },
            optionHelper: {
                textAlign: theme.body2xsTextAlign,
                [breakpoints.up(600)]: {
                    textAlign: theme.body2xsTextAlign + '!important'
                }
            },
            errorText: {
                textAlign: 'left!important'
            },
            checkedIcon: {
                left: -3
            },
            pagination: {}
        },
        light: {
            breakpoints,
            typography: {
                useNextVariants: true,
                fontFamily: '"' + theme.bodyFontFamily + '", sans-serif'
            },
            root: {
                marginTop: '0px!important',
                paddingBottom: 0
            },
            paper: {
                boxShadow: '0 12px 24px rgba(0, 0, 0, 0.15)!important',
                marginBottom: spacing * 3,
                paddingTop: spacing * 2 + 'px!important',
                background: theme.paperBackground,
                borderRadius: theme.borderRadius
            },
            header: {
                background: '#ffffff',
            },
            title: {
                paddingTop: spacing * 2.5,
                paddingBottom: spacing * 3
            },
            description: {
                color: 'rgba(0, 0, 0, 0.61)',
                marginBottom: 0,
                emptyMarginBottom: 0
            },
            button: {
                boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)!important'
            },
            selectButtons: {
                marginTop: spacing * 2
            },
            selectButton: {
                borderRadius: theme.borderRadius * 1.6,
                textTransform: 'none',
                padding: '10px 16px',
                fontSize: '1rem',
                letterSpacing: '0.2px',
                color: '#000000',
                boxShadow: 'none',
                fontWeight: 500,
                //textShadow: '0 0 1px rgba(0, 0, 0, 0.5)',
                nonSelectedBackground: '#e7e7e7'
            },
            textField: {
                border: null
            },
            forwardButton: {
                color: '#fff!important',
                background: '#04afff!important',
                boxShadow: 'none',
                width: 'auto',
                maxWidth: 498,
                marginTop: spacing * 0.8,
                marginBottom: spacing * 1.25,
                borderRadius: theme.borderRadius * 0.75
            },
            backButton: {
                color: 'rgba(0, 0, 0, 0.61)!important',
                marginTop: spacing * 0.8,
                marginBottom: spacing * 1,
                width: 'auto',
                maxWidth: 498,
                borderRadius: theme.borderRadius * 0.5
            },
            optionHelper: {
                textAlign: 'center',
                [breakpoints.up(600)]: {
                    textAlign: 'center!important'
                }
            },
            optionGroupTitle: {
                textAlign: 'center!important'
            },
            pagination: {}
        }
    }

    const themeWithPalette = baseTheme[theme.template ? theme.template : 'light']

    themeWithPalette.overrides = {
        MuiTypography: {
            h1: {
                padding: '0!important',
                textTransform: 'none!important',
                letterSpacing: '0!important',
                fontFamily: '"' + theme.headerFontFamily + '", sans-serif',
                marginTop: pxToRem(spacing * 2) + '!important',
                fontSize: pxToRem(spacing * 4) + '!important',
                [breakpoints.up('xs')]: {
                    fontSize: pxToRem(spacing * 4) + '!important'
                },
                [breakpoints.up('sm')]: {
                    fontSize: pxToRem(spacing * 4) + '!important'
                },
                [breakpoints.up(600)]: {
                    fontSize: pxToRem(spacing * 4) + '!important'
                },
                [breakpoints.up('lg')]: {
                    fontSize: pxToRem(spacing * 4) + '!important'
                }
            },
            h3: {
                padding: '0!important',
                textTransform: 'none!important',
                letterSpacing: '0!important',
                color: theme.xs.h3.color ? theme.xs.h3.color + '!important' : 'rgba(0, 0, 0, 1)!important',
                fontFamily: '"' + theme.headerFontFamily + '", sans-serif',
                marginTop: pxToRem(spacing * 3) + '!important',
                textAlign: theme.h3xsTextAlign + '!important',
                fontSize: theme.xs.h3.fontSize ? theme.xs.h3.fontSize + '!important' : '1.3rem!important',
                fontWeight: theme.xs.h3.fontWeight ? theme.xs.h3.fontWeight + '!important' : '600',
                [breakpoints.up(600)]: {
                    color: theme.md.h3.color ? theme.md.h3.color + '!important' : 'rgba(0, 0, 0, 1)!important',
                    fontSize: theme.md.h3.fontSize ? theme.md.h3.fontSize + '!important' : '1.8rem!important',
                    fontWeight: theme.md.h3.fontWeight ? theme.md.h3.fontWeight + '!important' : '500',
                    textAlign: theme.md.h3.textAlign + '!important'
                }
            },
            h4: {
                padding: '0!important',
                textTransform: 'none!important',
                letterSpacing: '0!important',
                color: theme.xs.h4.color ? theme.xs.h4.color + '!important' : 'rgba(0, 0, 0, 1)!important',
                fontFamily: '"' + theme.headerFontFamily + '", sans-serif',
                textAlign: theme.xs.h4.textAlign + '!important',
                marginTop: pxToRem(spacing * 3) + '!important',
                fontSize: theme.xs.h4.fontSize ? theme.xs.h4.fontSize + '!important' : '1.3rem!important',
                fontWeight: theme.xs.h4.fontWeight ? theme.xs.h4.fontWeight + '!important' : '600',
                [breakpoints.up(600)]: {
                    color: theme.md.h4.color ? theme.md.h4.color + '!important' : 'rgba(0, 0, 0, 1)!important',
                    fontSize: theme.md.h4.fontSize ? theme.md.h4.fontSize + '!important' : '1.8rem!important',
                    fontWeight: theme.md.h4.fontWeight ? theme.md.h4.fontWeight + '!important' : '500',
                    textAlign: theme.md.h4.textAlign + '!important'
                }
            },
            h5: {
                padding: '0!important',
                textTransform: 'none!important',
                letterSpacing: '0!important',
                color: theme.xs.h5.color ? theme.xs.h5.color + '!important' : 'rgba(0, 0, 0, 1)!important',
                fontFamily: '"' + theme.headerFontFamily + '", sans-serif',
                textAlign: theme.xs.h5.textAlign + '!important',
                marginTop: pxToRem(spacing * 3) + '!important',
                fontSize: theme.xs.h5.fontSize ? theme.xs.h5.fontSize + '!important' : '1.1rem!important',
                fontWeight: theme.xs.h5.fontWeight ? theme.xs.h5.fontWeight + '!important' : '600',
                [breakpoints.up(600)]: {
                    color: theme.md.h5.color ? theme.md.h5.color + '!important' : 'rgba(0, 0, 0, 1)!important',
                    fontSize: theme.md.h5.fontSize ? theme.md.h5.fontSize + '!important' : '1.5rem!important',
                    fontWeight: theme.md.h5.fontWeight ? theme.md.h5.fontWeight + '!important' : '500',
                    textAlign: theme.md.h5.textAlign + '!important'
                }
            },
            h6: {
                padding: '0!important',
                textTransform: 'none!important',
                letterSpacing: '0!important',
                fontFamily: '"' + theme.headerFontFamily + '", sans-serif',
                fontSize: '1rem!important',
                lineHeight: 1.4,
                marginBottom: spacing * 1.75 + 'px!important',
                textAlign: 'center!important'
            },
            body1: {
                color: theme.xs.body1.color ? theme.xs.body1.color + '!important' : 'rgba(0, 0, 0, 0.4)!important',
                fontSize: theme.xs.body1.fontSize ? theme.xs.body1.fontSize + '!important' : pxToRem(15) + '!important',
                fontWeight: theme.xs.body1.fontWeight ? theme.xs.body1.fontWeight + '!important' : '400',
                textAlign: theme.xs.body1.textAlign + '!important',
                [breakpoints.up(600)]: {
                    color: theme.md.body1.color ? theme.md.body1.color + '!important' : 'rgba(0, 0, 0, 0.4)!important',
                    fontSize: theme.md.body1.fontSize ? theme.md.body1.fontSize + '!important' : pxToRem(16) + '!important',
                    fontWeight: theme.md.body1.fontWeight ? theme.md.body1.fontWeight + '!important' : '400',
                    textAlign: theme.md.body1.textAlign + '!important'
                }
            },
            body2: {
                color: theme.xs.body2.color ? theme.xs.body2.color + '!important' : 'rgba(0, 0, 0, 0.4)!important',
                fontSize: theme.xs.body2.fontSize ? theme.xs.body2.fontSize + '!important' : pxToRem(16) + '!important',
                fontWeight: theme.xs.body2.fontWeight ? theme.xs.body2.fontWeight + '!important' : '400!important',
                textAlign: theme.body2xsTextAlign + '!important',
                [breakpoints.up(600)]: {
                    color: theme.md.body2.color ? theme.md.body2.color + '!important' : 'rgba(0, 0, 0, 0.4)!important',
                    fontSize: theme.md.body2.fontSize ? theme.md.body2.fontSize + '!important' : pxToRem(16) + '!important',
                    fontWeight: theme.md.body2.fontWeight ? theme.md.body2.fontWeight + '!important' : '400',
                    textAlign: theme.md.body2.textAlign + '!important'
                }
            },
            button: {
                fontSize: pxToRem(1.75) + '!important',
                [breakpoints.up(600)]: {
                    fontSize: pxToRem(spacing * 2) + '!important'
                }
            }
        }
    }

    themeWithPalette.colors = {
        primary: {
            main: theme.primaryColor,
            500: theme.primaryColor,
            600: pSBC(0.3, theme.primaryColor)
        },
        secondary: {
            main: theme.primaryColor,
            500: theme.secondaryColor,
            600: pSBC(0.3, theme.secondaryColor)
        }
    }

    themeWithPalette.palette = {
        primary: themeWithPalette.colors.primary,
        secondary: themeWithPalette.colors.secondary
    }

    if (theme.primaryColor) {
        themeWithPalette.palette.primaryColor = theme.primaryColor
        themeWithPalette.forwardButton.background = theme.primaryColor
    }

    if (theme.secondaryColor) {
        themeWithPalette.palette.secondaryColor = theme.secondaryColor
    }

    if (theme.boxShadow) {
        themeWithPalette.boxShadow = theme.boxShadow
        themeWithPalette.paper.boxShadow = theme.boxShadow
    }

    if (theme.bodyBackground) {
        themeWithPalette.bodyBackground = theme.bodyBackground
    }

    if (theme.headerBackground) {
        themeWithPalette.headerBackground = theme.headerBackground
    }

    if (theme.headerBoxShadow) {
        themeWithPalette.headerBoxShadow = theme.headerBoxShadow
    }

    if (theme.termsColor) {
        themeWithPalette.termsColor = theme.termsColor
    }

    if (theme.spacing) {
        themeWithPalette.spacing = theme.spacing
    }

    if (theme.logo) {
        themeWithPalette.logo = theme.logo
    }

    if (theme.inputVariant) {
        themeWithPalette.inputVariant = theme.inputVariant
    }

    if (theme.layout) {
        themeWithPalette.layoutAlias = theme.layout
    }

    if (theme.headerMarginTop) {
        themeWithPalette.headerMarginTop = theme.headerMarginTop
    }


    const containerDefaultMaxWidth = theme.layout === 'exclusive' ? 940 : 570

    themeWithPalette.borderRadius = theme.borderRadius ? theme.borderRadius : 20
    themeWithPalette.fontFamily = theme.fontFamily ? theme.fontFamily : '"Roboto", "Helvetica", "Arial", sans-serif'
    themeWithPalette.selectxsFontSize = theme.xs.select.fontSize ? theme.xs.select.fontSize : '1.0rem'
    themeWithPalette.selectxsWeight = theme.xs.select.fontWeight ? theme.xs.select.fontWeight : '400'
    themeWithPalette.selectmdFontSize = theme.md.select.fontSize ? theme.md.select.fontSize : '1.0rem'
    themeWithPalette.selectmdWeight = theme.md.select.fontWeight ? theme.md.select.fontWeight : '400'
    themeWithPalette.logoWidth = theme.logoWidth ? theme.logoWidth : 154
    themeWithPalette.body1Color = theme.body1Color ? theme.body1Color : 'rgba(0, 0, 0, 0.54)'
    themeWithPalette.body2Color = theme.body2Color ? theme.body2Color : 'rgba(0, 0, 0, 0.54)'
    themeWithPalette.body1xsTextAlign = theme.xs.body1.textAlign ? theme.xs.body1.textAlign : 'center'
    themeWithPalette.body1mdTextAlign = theme.md.body1.textAlign ? theme.md.body1.textAlign : 'center'
    themeWithPalette.body2xsTextAlign = theme.xs.body2.textAlign ? theme.xs.body2.textAlign : 'center'
    themeWithPalette.body2mdTextAlign = theme.md.body2.textAlign ? theme.md.body2.textAlign : 'center'
    themeWithPalette.containerWidthCenter = theme.containerWidthCenter ? theme.containerWidthCenter : containerDefaultMaxWidth

    if (theme.spacing) {
        themeWithPalette.spacing = parseInt(theme.spacing)
    }

    let muiTheme = null

    try {
        muiTheme = createMuiTheme(themeWithPalette)
    } catch (error) {
        console.log('Error on creating Mui Theme.')
    }

    if (!muiTheme) {
        return null
    }

    //console.log('muiTheme.spacing', muiTheme.spacing.unit)

    return muiTheme
}

const isValidTheme = theme => {
    const responsiveBreakpoints = ['xs', 'md']
    const typographyVariants = ['h3', 'h4', 'h5', 'body1', 'body2', 'select']
    const typographyAttributes = ['color', 'fontSize', 'fontWeight', 'textAlign']

    for (let responsiveBreakpoint of responsiveBreakpoints) {
        for (let typographyVariant of typographyVariants) {
            for (let typographyAttribute of typographyAttributes) {
                if (
                    !theme[responsiveBreakpoint] ||
                    !theme[responsiveBreakpoint][typographyVariant] ||
                    !theme[responsiveBreakpoint][typographyVariant][typographyAttribute]
                ) {
                    console.log('not set', responsiveBreakpoint, typographyVariant, typographyAttribute)
                    return false
                }
            }
        }
    }
    return true
}

export { getTheme, isValidTheme }
